import { render, staticRenderFns } from "./InsideDeal.vue?vue&type=template&id=5e315e21"
import script from "./InsideDeal.vue?vue&type=script&lang=js"
export * from "./InsideDeal.vue?vue&type=script&lang=js"
import style0 from "./InsideDeal.vue?vue&type=style&index=0&id=5e315e21&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports